import type { BillingGroupData } from "./types";

export const sortBillingGroups = (billingGroups: BillingGroupData[]): BillingGroupData[] => {
  const notAssignedGroup = billingGroups.find((g) => isNotAssignedGroup(g));
  const regularGroups = billingGroups.filter((g) => !isNotAssignedGroup(g));
  return notAssignedGroup ? [notAssignedGroup, ...regularGroups] : regularGroups;
};

export const isNotAssignedGroup = (group: BillingGroupData): boolean =>
  group.billingGroupId === null;

export const formatEumUsd = (value: number | null | undefined): string => {
  if (value == null) return "--";
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
